import { createUseStyles } from 'react-jss'

import { TextGreyBase, TextSlateGreyDarken12 } from '../../const/colors'
import { WidthBPs } from '../../const/commonStyles'
import { FontBody1, FontH3, FontH4 } from '../../const/fontStyles'

export default createUseStyles(
  {
    root: {
      height: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexDirection: 'column',
      padding: '0 24px',
      marginTop: 90,

      [`@media (min-width: ${WidthBPs.EXTRA_SMALL})`]: {
        padding: '0 40px',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 0,
      },
    },
    container: {
      maxWidth: 629,
      width: '100%',
      minHeight: 368,
      marginBottom: 32,
      flexShrink: 0,

      [`@media (min-width: ${WidthBPs.EXTRA_SMALL})`]: {
        marginBottom: 0,
      },
    },
    header: {
      marginBottom: 32,

      [`@media (min-width: ${WidthBPs.EXTRA_SMALL})`]: {
        marginBottom: 40,
      },
    },
    title: {
      ...FontH4,
      color: TextGreyBase,
      margin: '0 0 8px',

      [`@media (min-width: ${WidthBPs.EXTRA_SMALL})`]: {
        ...FontH3,
        margin: '0 0 16px',
      },
    },
    description: {
      ...FontBody1,
      color: TextSlateGreyDarken12,
      margin: 0,
    },
    error: {
      marginTop: 4,
    },
    inputGroup: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridGap: 16,
      marginBottom: 32,

      [`@media (min-width: ${WidthBPs.EXTRA_SMALL})`]: {
        gridGap: 24,
        marginBottom: 40,
      },
    },
    inputLabel: {
      marginBottom: 4,
    },
    buttonGroup: {
      display: 'flex',
      flexDirection: 'column',

      '& > *:first-child': {
        flexShrink: 1,
      },

      '& > *:last-child': {
        margin: '12px 0 0',
      },

      [`@media (min-width: ${WidthBPs.EXTRA_SMALL})`]: {
        flexDirection: 'row',

        '& > *:last-child': {
          margin: '0 0 0 12px',
        },
      },
    },
  },
  { name: 'Signin' }
)
